import React, { useEffect, useState } from 'react';
import useGameStore from '../../store/gameStore';
import { useSound } from '../../hooks/useSound';
import './ResultPopup.css';

export default function ResultPopup() {
  const { gameState, lastOutcome, lastWinAmount, betAmount, currentMultiplier, autoBet } = useGameStore();
  const { play } = useSound();
  const [visible, setVisible] = useState(false);
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    if (autoBet) { setVisible(false); return; }
    if (gameState === 'step_failed') {
      play('lose');
      setVisible(true);
    } else if (gameState === 'cashed_out') {
      play('win');
      spawnConfetti();
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [gameState, autoBet, play]);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => {
      setVisible(false);
      useGameStore.getState().resetRound();
    }, 1500);
    return () => clearTimeout(timer);
  }, [visible]);

  function spawnConfetti() {
    const colors = ['#f5c842','#39ff7a','#ff8c00','#4fc3f7','#b44fff','#ff3b5c'];
    setConfetti(Array.from({ length: 24 }, (_, i) => ({
      id: i,
      color: colors[i % colors.length],
      left: `${Math.random() * 100}%`,
      delay: Math.random() * 0.8,
      size: 6 + Math.random() * 8,
    })));
    setTimeout(() => setConfetti([]), 2500);
  }

  if (!visible) return null;

  const isWin = lastOutcome === 'cashout';

  return (
    <div className="popup-overlay" onClick={() => {
      setVisible(false);
      useGameStore.getState().resetRound();
    }}>
      {/* Confetti */}
      {confetti.map(c => (
        <div key={c.id} className="confetti-piece"
          style={{ left: c.left, animationDelay: `${c.delay}s`,
                   background: c.color, width: c.size, height: c.size }} />
      ))}

      <div className={`popup-card anim-pop-in ${isWin ? 'win' : 'lose'}`}
           onClick={e => e.stopPropagation()}>
        <div className="popup-icon">
          {isWin ? '🎉' : '💀'}
        </div>
        <h2 className="popup-title">
          {isWin ? 'Cashed Out!' : 'Crashed!'}
        </h2>
        {isWin ? (
          <>
            <div className="popup-mult">{currentMultiplier.toFixed(2)}×</div>
            <div className="popup-amount win-amount">+{lastWinAmount.toFixed(2)}</div>
            <p className="popup-sub">Great timing! 🐰✨</p>
          </>
        ) : (
          <>
            <div className="popup-amount lose-amount">−{betAmount.toFixed(2)}</div>
            <p className="popup-sub">The rabbit crashed… try again!</p>
          </>
        )}
        <button className="popup-close" onClick={() => {
          setVisible(false);
          useGameStore.getState().resetRound();
        }}>
          {isWin ? '🔥 Play Again' : '🔄 Try Again'}
        </button>
      </div>
    </div>
  );
}
